import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { deleteDockerImageQuery } from '../apis';
import { toast } from 'react-toastify';

const useDeleteDockerImage = () => {
  const mutateQuery = useMutation({
    mutationFn: deleteDockerImageQuery,
    onSuccess: () => {
      toast.success('Delete Docker Image successfully');
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Delete docker image:', error);
    },
  });

  return mutateQuery;
};

export default useDeleteDockerImage;
